import { toast } from "react-toastify";
import { onSuccess, useApiGet, useApiMutation } from "../utils/api";
import { SimpleForm } from "../utils/simple_form";
import { useState } from "react";

export const Account = () => {
  const { data, unavailable, refetch } = useApiGet("/api/user/account");
  const { post } = useApiMutation();

  if (unavailable) {
    return unavailable;
  }

  const { user } = data;

  const onSubmit = (user: any) => {
    post("/api/user/update_account", { user }).then(
      onSuccess(() => {
        toast.success("Profile updated");
        refetch();
      })
    );
  };

  return (
    <div className="container mt-4">
      <h1 className="mb-4">Account Settings</h1>

      <div className="col-md-4">
        <SimpleForm
          onSubmit={onSubmit}
          data={user}
          fields={{ first_name: {}, last_name: {} }}
        />

        <Friends />
      </div>
    </div>
  );
};

const Friends = () => {
  const { data, unavailable, refetch } = useApiGet("/api/user/friends");
  const { post, saving } = useApiMutation();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState<Record<string, string>>({});

  if (unavailable) {
    return unavailable;
  }

  const { friends } = data;

  const handleAddFriend = ({ email }) => {
    post("/api/user/add_friend", { email }).then(({ data }) => {
      if (data.success) {
        setEmail("");
        refetch();
        toast.success("Friend added!");
      } else if (data.error) {
        setErrors({ email: data.error });
      }
    });
  };

  return (
    <div>
      <h2 className="">Friends</h2>

      <ul className="list-unstyled mt-3">
        {friends && friends.length > 0 ? (
          friends.map((friend) => (
            <li key={friend.id} className="mb-2 d-flex align-items-center">
              <span className="mr-2">{friend.name || friend.email}</span>
              <span className="text-muted fs-12">{friend.email}</span>
            </li>
          ))
        ) : (
          <li className="text-muted">No friends yet.</li>
        )}
      </ul>

      <SimpleForm
        className="mt-5"
        fields={{
          email: {
            label: "Add Friend",
            required: true,
            placeholder: "Email",
          },
        }}
        data={{}}
        onSubmit={handleAddFriend}
        saving={saving}
        errors={errors}
        submitButtonText="Add Friend"
      />
    </div>
  );
};
